import type { ApprovalChain } from '../approval-chain.model';

export const LAND_TENURE_SUBDIVISION_CHAIN: ApprovalChain = {
  id: 'land-tenure-subdivision',
  label: 'Land Tenure Subdivision',
  applicationTypes: ['LAND_TENURE_SUBDIVISION'],
  steps: [
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['SUBMITTED', 'RESUBMITTED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Verify', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_VERIFIED' },
  ],
};
